'use strict';

angular.module('ecrd.queries')
    .component('queriesListClosed', {
        templateUrl: 'modules/queries/components/closed-queries/template.html',
        controller: 'queriesListClosedController',
        require: {
            main: '^queriesMain',
        },
    });
